module.exports = __webpack_public_path__ + "img/020.9ed12afa.png";